import classNames from "classnames";
import ProductImage from "../ProductImage";

function ProductImagesTrio({ className, images, imageSize }) {
  return (
    <div className={classNames("product-images-trio-container", className)}>
      {[0, 1, 2].map((index) => {
        const productPicture = images?.[index];

        return (
          <ProductImage
            key={`${productPicture}-${index}`}
            src={productPicture}
            sizes={imageSize}
            className="image-container"
          />
        );
      })}
    </div>
  );
}

export default ProductImagesTrio;
